module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUdwTABQ1wBS2QBS2ABR2gBQ0gBS2QBR2QBQ1wBS2Z6Eav4AAAAJdFJOUwAg736/EK+gUJsUfKIAAABbSURBVAjXY2BAAEanaQJghtDMmYpgRmap+BQwY6YA6yQwQzOAcSaY4VkYPg1VMWOmigADMuBwmjmTc+YEBgbLmRAGx0xTBgYQg2UyUJrTeAID51Qgg5nBAK4HAD8LE/X4J73eAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imag3.png
// module id = YECI
// module chunks = 0